<template>
    <div class="zzjs">
        <header class="b-relative">
            <img src="./images/banner.png" alt="banner" />
        </header>
        <section>
            <van-tabs
                v-model="active"
                scrollspy
                sticky
                :offset-top="$showTitle ? 46 : 0"
            >
                <van-tab title="产品详情">
                    <div class="mainbox">
                        <!-- 产品详情 -->
                        <div class="section-main">
                            <div class="floor module" id="character1">
                                <h1>新生代养老主义</h1>
                                <div class="md-main clearfix">
                                    <div class="left">
                                        <img src="./images/img1.png" alt="" />
                                        <p>不给子女增加额外负担</p>
                                    </div>
                                    <div class="right">
                                        <img src="./images/img2.png" alt="" />
                                        <p>更多自由闲暇时光</p>
                                    </div>
                                </div>

                                <div class="md-main clearfix">
                                    <div class="left">
                                        <img src="./images/img3.png" alt="" />
                                        <p>和伴侣、朋友到处旅行</p>
                                    </div>
                                    <div class="right">
                                        <img src="./images/img4.png" alt="" />
                                        <p>更体面的老年生活</p>
                                    </div>
                                </div>
                                <div class="text1">
                                    这些至少需要<span>100万</span>，你的退休金<span
                                        style="color:#ffaa00;"
                                        >够用吗？</span
                                    >
                                </div>
                                <div class="people">
                                    <div class="people1">
                                        <h3>
                                            举个栗子<img
                                                src="./images/eg.png"
                                                class="eg"
                                                alt=""
                                            />：诺小信
                                        </h3>
                                        <p>
                                            <label
                                                >32岁，现居上海，目前月收入<span
                                                    >10000元</span
                                                ></label
                                            >
                                        </p>
                                        <p>
                                            <label
                                                >退休后生活费需<span
                                                    >10000*70%=7000元</span
                                                ></label
                                            >
                                        </p>
                                    </div>
                                    <div class="people1 people2">
                                        <p>
                                            <label
                                                >55岁退休，不考虑通胀，养老<span
                                                    >至少20年</span
                                                ></label
                                            >
                                        </p>
                                        <p>
                                            <label
                                                >退休时需要：<span
                                                    >7000*12*20=168万元</span
                                                ></label
                                            >
                                        </p>
                                    </div>
                                </div>
                                <div class="getmoney">
                                    预计每月可领养老金<span>4959元</span>，共领取<span
                                        >119万</span
                                    >
                                </div>
                                <div class="redtext">还差49万！</div>
                                <div class="description">
                                    *根据世界银行报告，退休养老金需达退休前工资的70%（替代率），<br />
                                    才能保障有质量的养老生活哦！
                                </div>
                            </div>
                            <div id="character2" class="character">
                                <h1>
                                    选择自在金生<br />为你的未来攒出<span
                                        >小金库！</span
                                    >
                                </h1>
                                <h1>1. 生存总利益高 活越久领越多</h1>
                                <img
                                    src="./images/img7.png"
                                    class="lyimg"
                                    alt=""
                                />
                                <div class="scly">
                                    <p>
                                        <img
                                            src="./images/circle1.png"
                                            class="circle"
                                            alt=""
                                        />
                                        能领多少写进合同，不受市场因素影响
                                    </p>
                                    <p>
                                        <img
                                            src="./images/circle1.png"
                                            class="circle"
                                            alt=""
                                        />
                                        退休后每年/每月领取养老金，活到老领到老
                                    </p>
                                    <p>
                                        <img
                                            src="./images/circle1.png"
                                            class="circle"
                                            alt=""
                                        />
                                        保障终身，兼顾身故责任
                                    </p>
                                </div>
                            </div>
                            <div id="character3" class="character">
                                <h1>2. 低门槛投入 灵活缴费无压力</h1>
                                <h5>每月两杯奶茶钱，退休了专心养老</h5>
                                <div style="margin:0 0.18rem">
                                    <img
                                        src="./images/img8.png"
                                        class="lyimg"
                                        alt=""
                                    />
                                </div>

                                <div class="advantage2">
                                    <p>
                                        <img
                                            src="./images/circle1.png"
                                            class="circle"
                                            alt=""
                                        />
                                        多种缴费方式，经济压力较小，不会给家庭造成太大负担
                                    </p>
                                    <p>
                                        <img
                                            src="./images/circle1.png"
                                            class="circle"
                                            alt=""
                                        />
                                        最早可选55周岁起领取年金，灵活规划，退休自主
                                    </p>
                                </div>
                            </div>
                            <div id="character3" class="character">
                                <h1>3. 赠送基因检测服务</h1>
                                <img
                                    src="./images/img9.png"
                                    class="lyimg"
                                    alt=""
                                />
                                <div class="jyjc">
                                    <p>
                                        <img
                                            src="./images/checked.png"
                                            class="checked"
                                            alt=""
                                        />
                                        业界领先的基因检测技术
                                    </p>
                                    <p>
                                        <img
                                            src="./images/checked.png"
                                            class="checked"
                                            alt=""
                                        />
                                        评估未来患病的风险程度
                                    </p>
                                    <p>
                                        <img
                                            src="./images/checked.png"
                                            class="checked"
                                            alt=""
                                        />
                                        被保人和家人都可使用
                                    </p>
                                </div>
                                <div class="remarktext">
                                    备注：应监管要求重庆、河南、辽宁、佛山地区暂时无法使用该项服务
                                </div>
                                <!-- <a
                                    href="javascript:;"
                                    class="anchor-btn case-btn"
                                    @click="showCase = true"
                                    >点击查看投保案例</a
                                > -->
                            </div>
                            <!-- <div class="case-box" v-show="showCase">
                                <div class="case-inner">
                                    <div class="case-main">
                                        <div class="img10">投保案例</div>
                                        <div class="case-inner">
                                            <div class="case-item">
                                                <div class="character-part">
                                                    <label
                                                        ><span>诺小姐</span
                                                        ><span>35岁</span
                                                        ><span
                                                            >企业白领</span
                                                        ></label
                                                    >
                                                </div>
                                            </div>
                                            <div class="s-title">
                                                <div class="casecont">
                                                    <i></i
                                                    >诺小姐想要一个美好自在的老年生活，因此为自己投保了一份自在金生养老年金保险。主险基本保额为<span>30000元</span>。每月缴费<span>2328.24</span>元，选择缴费15年，共计缴费<span>419083.2元</span>。
                                                </div>
                                                <div class="casecont">
                                                    <i></i
                                                    >诺小姐选择<span>55周岁</span>后开始领取养老年金，每年可领<span>30000元</span>，一直生存则可以一直领取。若暂不急着用钱，也可选择暂不领取，进行养老年金累积生息。
                                                </div>
                                                <div class="casecont">
                                                    <i></i
                                                    >诺小姐85周岁时已累计领取养老年金<span
                                                        >930000元，累计领取养老年金/已缴保费≈<b>2.2</b>倍</span
                                                    ><b class="small-text"
                                                        >*85周岁指被保险人保单年度末年龄85岁</b
                                                    >
                                                </div>
                                            </div>
                                            <div
                                                class="close_btns"
                                                @click="showCase = false"
                                            >
                                                <span class="colse-case"
                                                    >收起案例</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </van-tab>
                <van-tab title="投保须知">
                    <div class="product-instruction">
                        <div class="section-title">
                            <h3 class="title">投保须知</h3>
                        </div>
                        <div class="section-main">
                            <table class="product-instable">
                                <tbody>
                                    <tr>
                                        <th>产品名称</th>
                                        <td>
                                            招商信诺自在金生年金保险计划
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>投保人年龄</th>
                                        <td>
                                            投保人须为年满18周岁且具有完全民事行为能力的自然人
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>被保人年龄</th>
                                        <td>出生满28天-55周岁</td>
                                    </tr>
                                    <tr>
                                        <th>保险期间</th>
                                        <td>
                                            终身
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>交费期间</th>
                                        <td>10年/15年/20年</td>
                                    </tr>
                                    <tr>
                                        <th>交费方式</th>
                                        <td>年交/半年交/季交/月交</td>
                                    </tr>
                                    <tr>
                                        <th>产品条款</th>
                                        <td>
                                            <a
                                                :href="
                                                    require('../../common/tiaokuan/zizaijinshengyanglaonianjinbaoxian.pdf')
                                                "
                                                target="_blank"
                                                @click="pdfPreview($event)"
                                                >主险：招商信诺自在金生养老年金保险</a
                                            ><br />
                                            <a
                                                :href="
                                                    require('../../common/tiaokuan/fujiahuomianbaoxianfeijibingbaoxian.pdf')
                                                "
                                                target="_blank"
                                                @click="pdfPreview($event)"
                                                >附加险：《招商信诺附加豁免保险费疾病保险》</a
                                            ><br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>投保地区</th>
                                        <td id="fname">
                                            广东、北京、上海、江苏、浙江、山东、四川、重庆、湖北、陕西、辽宁、湖南、河南、江西、天津、安徽、福建（不含厦门）
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <p class="reminder">
                                温馨提示：本网页仅供参考，不构成保险合同组成部分，保险责任、责任免除、等待期、理赔要求等重点内容，以条款为准。
                            </p>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="理赔流程">
                    <CustomerServiceGuide />
                </van-tab>
            </van-tabs>
        </section>
        <router-link to="" tag="footer">
            <button
                class="btn"
                :class="{ disabled: LGStatus }"
                @click="sendLG(2)"
            >
                {{ LGStatus ? "已预约" : "联系专属顾问" }}
            </button>
        </router-link>
    </div>
</template>

<script>
import mixin from "../../common/mixin.js";
import CustomerServiceGuide from "../../common/customer-service-guide/CustomerServiceGuide.vue";
export default {
    mixins: [mixin],
    components: { CustomerServiceGuide },
    data() {
        return {
            active: 0,
            showCase: false,
            code: "1GZ1DO0501BDANNY1",
            productName: "自在金生养老年金保险产品计划",
            method1: 14,
            method2: 3,
        };
    },
};
</script>
<style>
.zzjs .van-tabs__wrap {
    border-bottom: 1px solid #d0d0d0;
}
.zzjs .van-tabs {
    background: #f6f6f6;
    box-sizing: border-box;
}
.zzjs .van-tab {
    font-size: 0.14rem;
    color: #363636;
}
.zzjs .van-tab--active {
    font-size: 0.14rem;
    color: #3aaaf8;
}
.zzjs .van-tabs__line {
    width: 0.85rem;
    background: #3aaaf8;
}
.zzjs .mainbox {
    background: #fff;
    overflow: hidden;
}
.zzjs .head-btn .van-icon {
    top: 0.0134rem;
}
</style>
<style scoped>
.zzjs {
    height: 100vh;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    color: #2d2e2f;
}
.b-relative {
    position: relative;
}
.head-btn {
    position: absolute;
    bottom: 0.46rem;
    left: 0.14rem;
    width: 0.84rem;
    height: 0.23rem;
    font-family: FZLanTingHeiS-R-GB;
    font-weight: bold;
    line-height: 0.23rem;
    text-align: center;
    color: white;
    font-size: 0.11rem;
    background: linear-gradient(0deg, #fea914, #fb8e08);
    border-radius: 0.23rem;
}
.head-content {
    position: absolute;
    width: 1.54rem;
    top: 0.33rem;
    left: 0.16rem;
    font-size: 0.12rem;
    font-family: FZLanTingHeiS-R-GB;
    font-weight: 400;
    color: #ffffff;
    line-height: 0.2rem;
    text-shadow: 0rem 0rem 0rem rgba(118, 192, 251, 0.64);
}
img {
    width: 100%;
}
.content-title {
    font-size: 0.17rem;
    font-family: FZLTCHK;
    font-weight: bold;
    color: #4a4a4a;
}
.content-title_circle {
    display: inline-block;
    height: 0.05rem;
    width: 0.05rem;
    border-radius: 50%;
    margin-right: 0.11rem;
    background: linear-gradient(-28deg, #04abfd, #b8f2ff);
    margin-bottom: 0.02rem;
}
.content-img {
    margin-top: 0.22rem;
    margin-bottom: 0.15rem;
}
.content-min {
    margin-top: 0.2rem;
}
.mainbox .title {
    font-size: 0.15rem;
    font-weight: bold;
    color: #3aaaf8;
    padding-left: 0.16rem;
    box-sizing: border-box;
    position: relative;
    line-height: 0.44rem;
}
.mainbox .title::before {
    clear: both;
    content: "";
    display: inline-block;
    width: 0.06rem;
    height: 0.15rem;
    background: #3aaaf8;
    position: absolute;
    top: 50%;
    left: 0;
    border-radius: 0.06rem;
    transform: translateY(-50%);
}
/* 产品详情 */
#character1 {
    background-color: #fffdf5;
    padding: 0.3rem 0px 0.3rem;
}
#character1 h1 {
    color: #cc6204;
    font-size: 0.23rem;
    text-align: center;
    font-weight: 600;
    margin-bottom: 0.15rem;
}
.module .left,
.module .fl {
    float: left;
}
.module .right,
.module .fr {
    float: right;
}
.module .md-main {
    padding: 0 0.15rem 0;
}
.module .left,
.module .right {
    text-align: center;
    color: #666;
    font-size: 0.14rem;
}
#character1 img {
    margin-bottom: 0;
}
#character1 .md-main p {
    margin-top: 0.1rem;
    margin-bottom: 0.15rem;
}

.text1 {
    font-size: 0.17rem;
    color: #cc6204;
    font-weight: 600;
    text-align: center;
    margin-top: 0.1rem;
    margin-bottom: 0.2rem;
}
.text1 span {
    color: #f15b45;
}
.people {
    padding: 0px 0.1rem 0.1rem;
}
.people1 {
    padding-left: 0.8rem;
    background: url("./images/img5.png") no-repeat left center;
    background-size: 0.6rem auto;
    font-size: 0.12rem;
    background-position-y: 0.12rem;
    padding-bottom: 0.14rem;
}
.eg {
    width: 0.23rem;
}
.people1 h3 {
    color: #cc6204;
    font-weight: 600;
    padding-left: 0.12rem;
    margin-bottom: 0.05rem;
    font-size: 0.15rem;
}
.people1 p {
    color: #666;
    text-align: center;
    position: relative;
    margin-bottom: 0.05rem;
}
.people1 p label {
    position: relative;
    z-index: 2;
}
.people1 p:after {
    position: absolute;
    content: "";
    bottom: 0;
    height: 0.07rem;
    background-color: #fff6e5;
    width: 100%;
    left: 0;
    border-radius: 25px;
    z-index: 1;
}
.people1 p span,
.getmoney span {
    color: #ffaa00;
    font-weight: 600;
}
.getmoney {
    color: #666;
    text-align: center;
    margin-bottom: 0.1rem;
    font-size: 0.15rem;
}
.people2 {
    padding-left: 0.8rem;
    background: url("./images/img6.png") no-repeat left center;
    background-size: 0.6rem auto;
    font-size: 0.14rem;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
}
.redtext {
    color: #f25c47;
    font-weight: 600;
    font-size: 0.16rem;
    text-align: center;
    margin-bottom: 0.2rem;
}
.description {
    color: #999999;
    font-size: 0.11rem;
    padding: 0;
    line-height: 1.6;
    text-align: center;
}
#character2 {
    margin-top: 0.17rem;
}
.character h1 {
    font-size: 0.2rem;
    color: #cc6204;
    text-align: center;
    font-weight: 600;
    margin-bottom: 0.1rem;
}
#character2 h1 span {
    color: #ffaa00;
}
.lyimg {
    display: block;
    margin: 0.22rem auto 0;
    width: 100%;
}
.checked {
    width: 0.13rem;
}
.scly {
    background-color: #fffbed;
    font-size: 0.13rem;
    text-align: left;
    color: #666;
    padding: 0.12rem;
    margin: 0.18rem;
    border-radius: 0.08rem;
    line-height: 0.25rem;
}
.jyjc {
    background-color: #fffbed;
    border-radius: 5px;
    font-size: 0.14rem;
    text-align: center;
    color: #666;
    padding: 0.07rem 0px;
    margin: 0.15rem 0.15rem 0.16rem;
    line-height: 0.25rem;
}
.circle {
    width: 0.06rem;
}
.scly img {
    display: inline;
}
.cpts {
    color: #666;
}
.character h5 {
    font-size: 0.12rem;
    text-align: center;
    margin-bottom: 0.25rem;
    color: #666;
    font-weight: normal;
}
.advantage2 {
    background-color: #fffbed;
    border-radius: 0.08rem;
    padding: 0.14rem 0.1rem 0.14rem 0.25rem;
    margin: 0.18rem;
    line-height: 0.25rem;
    font-size: 0.13rem;
}
.advantage2 p {
    position: relative;
    text-align: left;
}
.advantage2 span {
    color: #ffaa00;
    font-weight: 600;
}
.advantage2 img {
    position: absolute;
    left: -0.12rem;
    top: 0.09rem;
}
.fjtext {
    font-size: 0.14rem;
}
.character h3 {
    color: #ffb400;
    font-weight: 600;
    font-size: 0.16rem;
    margin-top: 0.17rem;
}
.character {
    text-align: center;
    margin-bottom: 0.16rem;
}
.jyservice {
    margin-top: 0.25rem;
}
.remarktext {
    color: #999;
    margin: 0.2rem 0.08rem 0;
    font-size: 0.11rem;
    line-height: 1.7;
}
.character-part {
    margin-bottom: 0.15rem;
}
.case-main {
    background-color: #fffbed;
    border-radius: 5px;
    font-size: 0.13rem;
    text-align: left;
    padding: 0.9rem 0.12rem 0.3rem;
    position: relative;
    margin: 0 0.16rem;
}
.img10 {
    position: absolute;
    left: -0.07rem;
    top: 0rem;
    width: 100%;
    height: 0.85rem;
    color: #fff;
    font-size: 0.18rem;
    padding: 0.23rem 0.25rem 0rem;
    font-weight: 600;
    letter-spacing: 2px;
    background: url(./images/img10.png) no-repeat left center;
    background-size: 3.1rem 0.8rem;
}
.case-main label {
    position: relative;
    padding-left: 0.07rem;
    padding-right: 0.07rem;
    color: #cc6204;
    font-size: 0.15rem;
    font-weight: 600;
    padding-bottom: 0.07rem;
}
.character-part span {
    position: relative;
    margin-right: 0.17rem;
    z-index: 1;
}
.character-part span:last-child {
    margin-right: 0;
}
.character-part label:before {
    position: absolute;
    width: 100%;
    height: 0.07rem;
    background-color: #ffe7c2;
    border-radius: 0.16rem;
    left: 0;
    content: "";
    bottom: 0.07rem;
}
.case-inner .casecont {
    padding-bottom: 0.36rem;
    position: relative;
}
.case-inner .casecont:last-child {
    padding-bottom: 0;
}
.case-inner .casecont i {
    position: absolute;
    left: -0.17rem;
    top: 0.08rem;
    background: url("./images/circle2.png") no-repeat center center;
    background-size: 0.12rem 0.12rem;
    width: 0.12rem;
    height: 0.12rem;
}
/* .md-main img {
    width: 1.2rem;
} */

.case-inner .casecont span {
    font-weight: 600;
    color: #ffb400;
}
.case-inner .casecont b {
    font-weight: 600;
    color: #ff633f;
    margin-top: 0.07rem;
}
.small-text {
    display: block;
    font-size: 0.11rem;
    color: #999999 !important;
    font-weight: 400 !important;
}

.s-title {
    padding-left: 0.14rem;
    position: relative;
}
.s-title::before {
    display: block;
    content: "";
    position: absolute;
    z-index: 6;
    left: 0;
    top: 0.07rem;
    width: 0.02rem;
    height: 96.5%;
    background-color: #ffb400;
    background-repeat: no-repeat;
    background-position: center center;
}
.clearfix {
    *zoom: 1;
    clear: both;
}
.box-form .btn-form,
.anchor-btn {
    margin: 0.3rem auto;
    width: 2.25rem;
    display: block;
    font-size: 0.16rem;
    color: #fff;
    font-weight: bold;
    line-height: 0.4rem;
    background: #ff603e;
    text-align: center;
    border-radius: 0.46rem;
}
.close_btns {
    margin: 0.1rem auto 0.05rem;
    font-size: 0.15rem;
    color: #cc6204;
    text-align: center;
}
.close_btns span {
    display: inline-block;
    border-bottom: 1px solid;
    cursor: pointer;
}
/* 按钮 */
footer {
    padding: 0 0.15rem;
}
.btn {
    width: 100%;
    height: 0.37rem;
    background: #3b97ff;
    border-radius: 0.37rem;
    line-height: 0.37rem;
    border: none;
    font-size: 0.15rem;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 0.3rem;
    box-shadow: 0rem 0.03rem 0.05rem #3b97ff;
}
.btn.disabled {
    filter: grayscale(1);
}

.product-instruction {
    margin-top: 0.1rem;
    background: #fff;
}
.section-title {
    padding: 0.15rem;
    border-bottom: 1px solid #eee;
}
.section-title .title {
    font-size: 0.16rem;
    color: #333;
    line-height: 0.2rem;
    font-weight: bold;
}
.product-instruction .section-main {
    padding: 0.15rem 0.15rem 0.3rem;
}
.product-instable {
    margin-bottom: 0.15rem;
    border: 1px solid #eee;
    width: 100%;
    font-size: 0.13rem;
    line-height: 0.2rem;
    border-collapse: collapse;
    border-spacing: 0;
}
.product-instable th {
    padding: 0.1rem 0.1rem;
    width: 30%;
    color: #777;
    background: #f5f5f5;
    border: 1px solid #fff;
    font-weight: normal;
}
.product-instable td {
    padding: 0.1rem 0.05rem 0.1rem 0.15rem;
    width: 70%;
    border: 1px solid #eee;
}
.product-instable a {
    color: #3aaaf8;
}
.product-instruction .reminder {
    font-size: 0.11rem;
    color: #999;
}
</style>
